import { Stack, ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";

export default function StackCustom(props) {
  const {stackConfig, children, setSwitchCase, switchCase} = props

  const handleSwitch = (event, newAlignment) => {
    if (newAlignment !== null) {
      setSwitchCase(newAlignment);
    }
  };

  return (
    <Stack direction="row" spacing={4}>
      <ToggleButtonGroup
        className="graphic-choice"
        value={switchCase}
        exclusive
        onChange={handleSwitch}
        aria-label="text alignment">
        {stackConfig.map((button, index) => (
          <ToggleButton value={button.value} key={index}>
            <Tooltip title={button.title}>
              {button.icon}
            </Tooltip>
          </ToggleButton>
        ))}
      </ToggleButtonGroup> 
      {children}
    </Stack>
  )
}
